import { v4 as uuidv4 } from "uuid";
import { NoteBlock } from "../block";

export interface ServiceAccountBlock extends NoteBlock {
  "service-account-id": string;
  type: "omega/query-omega/page/block/service-account/ServiceAccountBlock";
}

export function isServiceAccountBlock(
  block: NoteBlock,
): block is ServiceAccountBlock {
  return (block as ServiceAccountBlock)["service-account-id"] !== undefined;
}

export const newServiceAccountBlock = (config: {
  appId: string;
  pageId: string;
  serviceAccountId: string;
  blockIndex: number;
}): ServiceAccountBlock => {
  const { appId, pageId, serviceAccountId, blockIndex } = config;
  return {
    "service-account-id": serviceAccountId,
    type: "omega/query-omega/page/block/service-account/ServiceAccountBlock",
    "block-index": blockIndex,
    "page-id": pageId,
    "app-id": appId,
    "block-id": uuidv4(),
  };
};
